"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _this = void 0;

/**
 * Function to rate limit execution of another function.
 * Useful for limiting scroll, preventing double clicks etc.
 *
 * @param {function} callback - Function to be called after specified time
 * @param {number} wait - Time delay
 * @param {boolean} immediate - Should execute once, before time delay
 * @return {function} - Sets delay and executes callback pushed to it as arg
 *
 */
var _default = function _default(callback, wait, immediate) {
  var timeout;
  return function () {
    var context = _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var funcArgs = args;
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;

      if (!immediate) {
        callback.apply(context, funcArgs);
      }
    }, wait);
    if (callNow) callback.apply(context, funcArgs);
  };
};

exports["default"] = _default;